import React, {useEffect} from 'react';
import {ErrorBoundary} from 'react-error-boundary';
import {initWeirwood, captureException} from '../../../utils/weirwood';

const WeirwoodErrorBoundary = props => {
    useEffect(() => {
        initWeirwood();
    }, []);

    const fallbackRender = ({error, resetErrorBoundary}) => {
        if (process.env.NODE_ENV === 'production' && location.hostname === 'huibo.baidu.com') {
            captureException(error);
            window.location.reload();
        }
    };

    return (
        <ErrorBoundary fallbackRender={fallbackRender}>
            {props.children}
        </ErrorBoundary>
    );
};

export default WeirwoodErrorBoundary;
